<template>
  <div
    class="z-10 flex h-[53px] min-w-0 shrink-0 items-center justify-between gap-4 bg-white px-4 transition dark:bg-sidebar"
    :class="[isScrolled && 'scrolling']"
  >
    <div class="flex min-w-0 items-center gap-3">
      <slot name="title">
        <div v-if="image" class="size-4 shrink-0 overflow-hidden rounded">
          <img :src="image" class="size-full object-cover" />
        </div>
        <component
          :is="iconComponent"
          v-if="iconComponent"
          class="size-4 text-purple-500"
        />

        <span
          v-if="pending"
          class="block h-4 w-24 shrink-0 animate-pulse rounded-md bg-gray-200 dark:bg-muted-foreground"
        >
        </span>
        <span
          v-else
          :id="id"
          class="truncate text-sm font-semibold text-black dark:text-white"
        >
          {{ title }}
        </span>
      </slot>
    </div>

    <div class="-mr-2 flex min-w-0 shrink-0 items-center gap-2">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Component, computed } from "vue";

import {
  type MappedIconMicro,
  iconMappingMicro,
} from "@/icons/icon-mapping-micro";

const props = defineProps<{
  title: string;
  id?: string;
  image?: string;
  icon?: Component | MappedIconMicro;
  isScrolled?: boolean;
  pending?: boolean;
}>();

const iconComponent = computed((): Component | undefined => {
  const icon = props.icon;

  if (typeof icon === "string") {
    return iconMappingMicro[icon];
  }

  return icon;
});
</script>

<style>
.scrolling {
  box-shadow: 0 1px 0 0 var(--color-muted);
}
</style>
